import React, { useEffect, useRef } from 'react';
import { createParticles } from '../utils/gameUtils';
import './GameBoard.css';

const ParticleEffect = ({ color, x, y, gameboardRef }) => {
  const effectRef = useRef(null);
  
  useEffect(() => {
    if (gameboardRef.current && effectRef.current) {
      const particles = createParticles(x, y, color);
      
      particles.forEach(particle => {
        gameboardRef.current.appendChild(particle);
      });
      
      // 파티클 제거 타이머
      const cleanupTimer = setTimeout(() => {
        particles.forEach(particle => {
          if (particle.parentNode === gameboardRef.current) {
            gameboardRef.current.removeChild(particle);
          }
        });
      }, 1500); // 모든 파티클이 사라질 충분한 시간
      
      return () => {
        clearTimeout(cleanupTimer);
        particles.forEach(particle => {
          if (particle.parentNode === gameboardRef.current) {
            gameboardRef.current.removeChild(particle);
          }
        });
      };
    }
  }, [color, x, y, gameboardRef]);
  
  return <div ref={effectRef} className="particle-container"></div>;
};

export default ParticleEffect;
